import React from 'react'
import CloudStorage from '../../CloudStorage/CloudStorage'
import { addpresent } from './FewCommonMethods'

export default function MilestonesDisplay({ formData }) {
    return (
        <div>
            <div className="table-responsive">
                <table className="table">
                    <thead>
                        <tr>
                            <th scope="col">Milestones</th>
                            <th scope="col">Deadline</th>
                            <th scope="col">Amount</th>
                            <th scope="col">
                                Penalty
                                <img
                                    data-tooltip-id="my-tooltip-1"
                                    src={`${CloudStorage.cloudurl}/Assets/Images/project/penalty.svg`}
                                    alt=""
                                />
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {Array.isArray(formData?.milestones) &&
                            formData?.milestones.map((item, index) => (
                                <tr>
                                    <td>
                                        {index + 1}. {item.title}
                                    </td>
                                    <td>
                                        {item.duration ? item.duration : "-----"} {" "}
                                        {item?.duration_type == 2
                                            ? "Days"
                                            : item?.duration_type == 3
                                                ? "Weeks"
                                                : item?.duration_type == 4
                                                    ? "Months"
                                                    : ""}
                                    </td>
                                    <td>
                                        {item.amount ? "$" : ""}
                                        {item.amount ? item.amount : "-----"}
                                    </td>
                                    <td>
                                        {item.penalty
                                            ? addpresent(item.penalty)
                                            : "-----"}
                                    </td>
                                </tr>
                            ))}
                    </tbody>
                </table>
            </div>
        </div>
    )
}
